import { classes as r } from "../classes/classes.js";
import '../assets/RadioAsButton.css';const i = "op_radioAsButtonInput_NxfvL", A = "op_radioAsButtonLabel_hhLw0", B = "op_radioAsButtonSelected_1GG8z", p = "op_radioAsButtonHolder_hRCUP", a = {
  radioAsButtonInput: i,
  radioAsButtonLabel: A,
  radioAsButtonSelected: B,
  radioAsButtonHolder: p
};
function N(u) {
  let {
    choices: d = [],
    value: s,
    labelAttri: e = {},
    inputAttri: o = {}
  } = u;
  return /* @__PURE__ */ React.createElement("div", { className: a.radioAsButtonHolder }, d.map((t) => {
    var l, n;
    return /* @__PURE__ */ React.createElement(
      "label",
      {
        ...e,
        ...t == null ? void 0 : t.labelAttri,
        className: r(a.radioAsButtonLabel, s == t.value ? a.radioAsButtonSelected : null, e == null ? void 0 : e.className, (l = t == null ? void 0 : t.labelAttri) == null ? void 0 : l.className)
      },
      t.label,
      /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "radio",
          checked: s == t.value ? "checked" : "",
          value: t.value,
          ...o,
          ...t == null ? void 0 : t.inputAttri,
          className: r(a.radioAsButtonInput, o == null ? void 0 : o.className, (n = t == null ? void 0 : t.inputAttri) == null ? void 0 : n.className)
        }
      )
    );
  }));
}
export {
  N as RadioAsButton
};
